export const getCurrentDay = () => {
  const date = new Date();
  return `${date.getFullYear()}${dateIndex(date.getMonth() + 1)}${dateIndex(date.getDate())}`;
};

const dateIndex = (index: number) => {
  const indexString = index < 10 ? `0${index}` : `${index}`;
  return indexString;
};
